<template>
  <div class="ux-btn-group">
    <slot />
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.ux-btn-group {
  display: inline-flex;
  vertical-align: top;

  // Soft outer corners on the group, flat where buttons touch.
  --btn-group-border-radius: 0.5em;

  :deep(.ux-btn) {
    // Buttons sit flush — drop the inter-button gap and pill rounding.
    margin: 0;
    border-radius: 0;

    // Subtle divider between adjacent buttons so same-colour
    // buttons stay distinct.
    &:not(:first-child) {
      border-left: 1px solid color-mix(in lab, currentColor 15%, transparent);
    }

    // Rounded bookends (also overrides icon buttons' 50% radius).
    &:first-child {
      border-top-left-radius: var(--btn-group-border-radius);
      border-bottom-left-radius: var(--btn-group-border-radius);
    }

    &:last-child {
      border-top-right-radius: var(--btn-group-border-radius);
      border-bottom-right-radius: var(--btn-group-border-radius);
    }
  }
}
</style>
